const generalConstants = {
  imageSize: 500,
  RECORD_LIMIT: 10,
  RECORD_SKIP: 0,
  NOT_AVAILABLE: 'N/A',
  PASS: 'pass',
  FAIL: 'fail',
  NO_RECORD_fOUND: 'No Record found',
  DAY_RANGE: ['monday', 'sunday'],
  TIME_RANGE: ['0:00 am', '0:00 am'],
  WEEK_START_DAY: 'Monday',
  MONTH: 'Month',
  WEEK: 'Week',
  DAY: 'Day',
  MYQAMPUS_VIDEO: 'https://www.youtube.com/embed/y2_80BoV-rY?rel=0&loop=1',
}
export const ROLES_LIST = [
  { id: '0', name: 'Student' },
  { id: '1', name: 'All Student' },
  { id: '2', name: 'Teacher' },
  { id: '3', name: 'All Teacher' },
  { id: '4', name: 'Gaurdian' },
  { id: '5', name: 'All Gaurdian' },
  { id: '6', name: 'Staff' },
  { id: '7', name: 'All Staff' },
]

export const MEDIUM_LIST = [
  { id: '1', name: 'Email' },
  { id: '2', name: 'Sms' },
  { id: '3', name: 'Web Push Notifications' },
]
export const CARD_LIST = [
  {
    parentRoute: 'features',
    modal: 'feature-detail-modal',
    routeName: 'fee-manager',
    symbol: 'fee-manager',
    title: 'FHE_C1_T',
    description: ['FHE_C1_D1', 'FHE_C1_D2', 'FHE_C1_D3', 'FHE_C1_D4', 'FHE_C1_D5'],
    color: 'primary-purple-600',
    shadow: 'shadow-primary-purple-600',
    showCard: true,
  },
  {
    parentRoute: 'features',
    modal: 'feature-detail-carousel-modal',
    routeName: 'attendance-manager',
    symbol: 'attendance-manager',
    title: 'FHE_C2_T',
    description: ['FHE_C2_D1', 'FHE_C2_D2', 'FHE_C2_D3', 'FHE_C2_D4', 'FHE_C2_D5'],
    color: 'secondary-orange-500',
    shadow: 'shadow-secondary-orange-500 ',
    showCard: true,
  },
  {
    parentRoute: 'features',
    modal: 'feature-detail-modal',
    routeName: 'timetable-manager',
    symbol: 'time-manager',
    title: 'FHE_C3_T',
    description: ['FHE_C3_D1', 'FHE_C3_D2', 'FHE_C3_D3', 'FHE_C3_D4', 'FHE_C3_D5'],
    color: 'success-500',
    shadow: 'shadow-primary-light-green ',
    showCard: true,
  },
  {
    parentRoute: 'features',
    modal: 'feature-detail-carousel-modal',
    routeName: 'syllabus-manager',
    symbol: 'syllabus',
    title: 'FHE_C4_T',
    description: ['FHE_C4_D1', 'FHE_C4_D2', 'FHE_C4_D3', 'FHE_C4_D4', 'FHE_C4_D5'],
    color: 'error-600',
    shadow: 'shadow-error-600',
    showCard: true,
  },
  {
    parentRoute: 'features',
    modal: 'feature-detail-modal',
    routeName: 'notification-and-reminder',
    symbol: 'notification',
    title: 'FHE_C5_T',
    description: ['FHE_C5_D1', 'FHE_C5_D2', 'FHE_C5_D3', 'FHE_C5_D4', 'FHE_C5_D5'],
    color: 'warning-500',
    shadow: 'shadow-warning-500',
    showCard: true,
  },
  {
    parentRoute: 'features',
    modal: 'feature-detail-carousel-modal',
    routeName: 'roles-and-permissions',
    symbol: 'setting',
    title: 'FHE_C6_T',
    description: ['FHE_C6_D1', 'FHE_C6_D2', 'FHE_C6_D3', 'FHE_C6_D4', 'FHE_C6_D5'],
    color: 'secondary-blue-600',
    shadow: 'shadow-secondary-blue-600',
    showCard: false,
    // this
  },
  {
    parentRoute: 'features',
    modal: 'feature-detail-modal',
    routeName: 'white-labelling',
    symbol: 'white-label',
    title: 'FHE_C7_T',
    description: ['FHE_C7_D1', 'FHE_C7_D2', 'FHE_C7_D3', 'FHE_C7_D4', 'FHE_C7_D5'],
    color: 'secondary-blue-gray-500',
    shadow: 'shadow-secondary-blue-gray-500',
    showCard: false,
    // this
  },
  {
    parentRoute: 'features',
    modal: 'feature-detail-carousel-modal',
    routeName: 'pickup-facility',
    symbol: 'user',
    title: 'FHE_C8_T',
    description: ['FHE_C8_D1', 'FHE_C8_D2', 'FHE_C8_D3', 'FHE_C8_D4', 'FHE_C8_D5'],
    color: 'secondary-rose-500',
    shadow: 'shadow-secondary-rose-500',
    showCard: true,
  },
  {
    parentRoute: 'features',
    modal: 'feature-detail-carousel-modal',
    routeName: 'announcements',
    symbol: 'notification',
    title: 'ANNOUNCEMENT',
    description: [
      'ANNOUNCEMENTS_DESCRIPTION1',
      'ANNOUNCEMENTS_DESCRIPTION2',
      'ANNOUNCEMENTS_DESCRIPTION3',
      'ANNOUNCEMENTS_DESCRIPTION4',
      'ANNOUNCEMENTS_DESCRIPTION5',
    ],
    color: 'primary-purple-600',
    shadow: 'shadow-primary-purple-600',
    showCard: true,
  },
  {
    parentRoute: 'features',
    modal: 'feature-detail-carousel-modal',
    routeName: 'exams',
    symbol: 'attendance-manager',
    title: 'EXAMS',
    description: [
      'EXAMS_DESCRIPTION1',
      'EXAMS_DESCRIPTION2',
      'EXAMS_DESCRIPTION3',
      'EXAMS_DESCRIPTION4',
      'EXAMS_DESCRIPTION5',
    ],
    color: 'secondary-orange-500',
    shadow: 'shadow-secondary-orange-500 ',
    showCard: true,
  },
  {
    parentRoute: 'features',
    modal: 'feature-detail-carousel-modal',
    routeName: 'assignments',
    symbol: 'syllabus',
    title: 'ASSIGNMENT',
    description: [
      'ASSIGNMENTS_DESCRIPTION1',
      'ASSIGNMENTS_DESCRIPTION2',
      'ASSIGNMENTS_DESCRIPTION3',
      'ASSIGNMENTS_DESCRIPTION4',
      'ASSIGNMENTS_DESCRIPTION5',
    ],
    color: 'success-500',
    shadow: 'shadow-primary-light-green ',
    showCard: true,
  },
  {
    parentRoute: 'features',
    modal: 'feature-detail-carousel-modal',
    routeName: 'parent-teacher-meetings',
    symbol: 'time-manager',
    title: 'APPOINTMENT',
    description: [
      'APPOINTMENT_DESCRIPTION1',
      'APPOINTMENT_DESCRIPTION2',
      'APPOINTMENT_DESCRIPTION3',
      'APPOINTMENT_DESCRIPTION4',
      'APPOINTMENT_DESCRIPTION5',
    ],
    color: 'error-600',
    shadow: 'shadow-error-600',
    showCard: true,
  },
  {
    parentRoute: 'features',
    modal: 'feature-detail-carousel-modal',
    routeName: 'parents-query-management',
    symbol: 'user',
    title: 'SUPPORT',
    description: [
      'SUPPORT_DESCRIPTION1',
      'SUPPORT_DESCRIPTION2',
      'SUPPORT_DESCRIPTION3',
      'SUPPORT_DESCRIPTION4',
      'SUPPORT_DESCRIPTION5',
    ],
    color: 'warning-500',
    shadow: 'shadow-warning-500',
    showCard: true,
  },
  {
    parentRoute: 'features',
    modal: 'feature-detail-carousel-modal',
    routeName: 'grading-system',
    symbol: 'fee-manager',
    title: 'GRADING_SYSTEM',
    description: [
      'GRADING_SYSTEM_DESCRIPTION1',
      'GRADING_SYSTEM_DESCRIPTION2',
      'GRADING_SYSTEM_DESCRIPTION3',
      'GRADING_SYSTEM_DESCRIPTION4',
      'GRADING_SYSTEM_DESCRIPTION5',
    ],
    color: 'secondary-blue-gray-500',
    shadow: 'shadow-secondary-blue-gray-500',
    showCard: true,
  },
]

/**
 * User Constants
 */
export const USER_CONSTANTS = {
  GENDERS: [
    { title: 'MALE', value: 'male' },
    { title: 'FEMALE', value: 'female' },
    { title: 'OTHERS', value: 'others' },
    { title: 'NOT_SELECTED', value: '' },
  ],
  LOGIN_ENABLED_STATUSES: [
    { title: 'YES', value: true },
    { title: 'NO', value: false },
  ],
}

export const navbarLinks = [
  { to: '/features', activeNavBarLink: 'Features', name: 'Features' },
  { to: '/pricing', activeNavBarLink: 'pricing', name: 'Pricing' },
  { to: '/about-us', activeNavBarLink: 'About_Us', name: 'About Us' },
]

export const NOTIFICATION_STATUS = {
  READ: 'Read',
  UNREAD: 'Unread',
  READ_ALL_SMALL: 'read',
  UNREAD_ALL_SMALL: 'unread',
}

export const COMMUNICATION_MEDIUMS = {
  WEBPUSH: 'webpush',
  SMS: 'sms',
  EMAIL: 'email',
}

export const weekDays = [
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
  'sunday',
]

export const MONTHS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
]

export const DEFAULT_LANGUAGE = {
  id: 0,
  short: 'en',
  long: 'English',
  dir: 'ltr',
}

export default generalConstants
